import api from '../services/api';

// Post-completion prompt: offer to open the project in Site Tracker to send to the client.
export default function SubmitToClientModal({ projectId, onClose }) {
  async function openSiteTracker() {
    try {
      const { data } = await api.get(`/jobs/${projectId}/sf-url`);
      window.open(data.url, '_blank', 'noopener');
    } catch {
      alert('Could not open Site Tracker for this project — you can open the project record manually to send.');
    }
    onClose();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-md rounded-xl border border-navy-500 p-6 text-center" style={{ backgroundColor: '#142236' }}>
        <div className="text-4xl mb-3">✅</div>
        <h2 className="text-white font-bold text-lg mb-1">Job Completed</h2>
        {projectId && <p className="text-gray-500 text-xs mb-4 font-mono">{projectId}</p>}
        <p className="text-gray-200 text-sm mb-6">Would you like to submit it to the client?</p>
        <div className="flex gap-3">
          <button
            onClick={openSiteTracker}
            className="flex-1 bg-gold-500 text-navy-900 py-2.5 rounded font-bold uppercase tracking-wide text-sm hover:bg-gold-400 transition"
          >
            Yes — Send to Client
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2.5 rounded border border-navy-500 text-gray-400 text-sm hover:text-white hover:border-gray-400 transition"
          >
            Not now
          </button>
        </div>
        <p className="text-gray-500 text-xs mt-4">Opens this project in Site Tracker, where you can pick files and click “Send File to Customer.”</p>
      </div>
    </div>
  );
}
